import {
	GoogleReviewLongButtonCurrent,
	type GoogleReviewSealSize,
} from './googleReviewVariants';

type GoogleReviewsSectionProps = {
	sealSize?: GoogleReviewSealSize | null;
	variant?: 'default' | 'newLanding';
};

const GoogleReviewsSection = ({
	sealSize,
	variant = 'default',
}: GoogleReviewsSectionProps) => {
	return (
		<GoogleReviewLongButtonCurrent sealSize={sealSize} variant={variant} />
	);
};

export { GoogleReviewsSection };
